import { Injectable } from '@angular/core';
import { tap, mapTo } from 'rxjs/operators';
import { ApiService } from '../../shared/services/core/api.service';
import { MemberQuery } from '../member/member.query';
import { MemberLoyaltyStatus } from '../member-loyalty-status/member-loyalty-status.model';
import { MemberLoyaltyStatusStore } from './member-loyalty-status.store';
import { config } from '../../shared/config';

@Injectable({ providedIn: 'root' })
export class MemberLoyaltyStatusService {
  constructor(private memberLoyaltyStatusStore: MemberLoyaltyStatusStore, private api: ApiService, private memberQuery: MemberQuery) {}

  fetchMemberLoyaltyStatus() {
    const user = this.memberQuery.getUserContext();
    return this.api.getAnySingle<MemberLoyaltyStatus>(`members/${user.memberId}/loyalty/${config.purseConfig.virtualLoyalty}`).pipe(
      tap(loyaltyStatus => this.memberLoyaltyStatusStore.update(loyaltyStatus)),
      mapTo(null)
    );
  }
}